import {
  ICarrierBidDirectionTypes,
  ICarrierBidSourceTypes,
  ICreateBidInput,
} from 'types/graphqlTypes'
import { TCarrierOptionSchema } from '../schema/CarrierOptionSchema'

interface IGetCreateBidInputProps {
  formData: TCarrierOptionSchema
  shipmentId: string
}

export const getCreateBidInput = ({
  formData,
  shipmentId,
}: IGetCreateBidInputProps): ICreateBidInput => {
  const {
    amount,
    carrierApplication,
    carrierContactName,
    carrierContactPhone,
    carrierContactPhoneExt,
    carrierContactUserId,
    counterOfferAmount,
    getApproval,
    nonBookable,
    note,
    sourceChannel,
    sourceSegment,
  } = formData || {}
  const { id: carrierApplicationId } = carrierApplication || {}
  return {
    bid: {
      amount: amount || 0,
      carrierApplicationId,
      carrierContactName,
      carrierContactPhone,
      carrierContactPhoneExt,
      carrierContactUserId,
      counterBidAmount: counterOfferAmount,
      note,
      shipmentId,
      source: ICarrierBidSourceTypes.manual,
      direction: ICarrierBidDirectionTypes.inbound,
      sourceChannel,
      sourceSegment,
      isNotBookable: nonBookable,
      createBidApproval: getApproval,
    },
  }
}
